// API URL configuration utility
export const getApiUrl = (): string => {
  // Use environment variable if set (check both possible names)
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }
  
  // Fallback to production or development URLs
  if (import.meta.env.PROD) {
    return 'https://server.waddleandsip.com';
  }
  
  return 'http://localhost:3001';
};

// Helper function to build API endpoints
export const buildApiUrl = (endpoint: string): string => {
  const baseUrl = getApiUrl();
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
}; 